var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3999 5.5C12.2299 5.5 12.8949 4.83 12.8949 4C12.8949 3.17 12.2299 2.5 11.3999 2.5C10.5699 2.5 9.8999 3.17 9.8999 4C9.8999 4.83 10.5699 5.5 11.3999 5.5ZM7.3999 5.5C8.2299 5.5 8.8949 4.83 8.8949 4C8.8949 3.17 8.2299 2.5 7.3999 2.5C6.5699 2.5 5.8999 3.17 5.8999 4C5.8999 4.83 6.5699 5.5 7.3999 5.5ZM7.3999 6.5C6.2349 6.5 3.8999 7.085 3.8999 8.25V9.5H10.8999V8.25C10.8999 7.085 8.5649 6.5 7.3999 6.5ZM11.3999 6.5C11.2549 6.5 11.0899 6.51 10.9149 6.525C11.4949 6.945 11.8999 7.51 11.8999 8.25V9.5H14.8999V8.25C14.8999 7.085 12.5649 6.5 11.3999 6.5Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.96 5.808V6.512H2.072V7.48H1.28V6.512H0.392V5.808H1.28V4.84H2.072V5.808H2.96Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(3.3999)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPerson);
export default __webpack_public_path__ + "static/media/add-person.4befb3e8.svg";
export { ForwardRef as ReactComponent };